import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { app_permissions } from '../../../security/app-permissions';
import { PermissionService } from '../../../security/permission.service';
import { PageDataPanelComponent } from '../../../shared/page-layout/page-data-panel.component';
import { MyHrApprovalsWorkspace } from '../shared/my-hr-workspace.models';
import { MyHrWorkspaceService } from '../shared/my-hr-workspace.service';
import { labelize, statusSeverity } from '../shared/my-hr-workspace.utils';

@Component({
  selector: 'app-my-hr-approvals',
  standalone: true,
  imports: [CommonModule, TableModule, TagModule, PageDataPanelComponent],
  templateUrl: './my-hr-approvals.component.html',
  styleUrls: ['./my-hr-approvals.component.scss']
})
export class MyHrApprovalsComponent implements OnInit {
  private readonly workspaceService = inject(MyHrWorkspaceService);
  private readonly permissionService = inject(PermissionService);

  readonly canViewSelf = this.permissionService.hasPermission(app_permissions.hr.self.view);
  readonly canViewManager = this.permissionService.hasPermission(app_permissions.hr.manager.view);
  readonly canApproveExpenses = this.permissionService.hasPermission(app_permissions.expense.approval.view);

  workspace?: MyHrApprovalsWorkspace;

  ngOnInit(): void {
    this.load();
  }

  label(value?: string): string {
    return labelize(value);
  }

  statusSeverity(value?: string): 'success' | 'secondary' | 'info' | 'warn' | 'danger' {
    return statusSeverity(value);
  }

  private load(): void {
    this.workspaceService.loadApprovalsWorkspace(this.canViewSelf, this.canViewManager, this.canApproveExpenses).subscribe({
      next: workspace => {
        this.workspace = workspace;
      },
      error: () => {
        this.workspace = undefined;
      }
    });
  }
}
